import * as moment from 'moment';
import { AlertThickness } from './alert-thickness.model';

import { BT, Line, Observation, PK } from './models';

export class Measure {
  id: number;
  bt: BT;
  centralPart: number = 0;
  date: string;
  height: number = 0;
  isImpossible: boolean = false;
  isSpecific: boolean = false;
  length: number = 0;
  line: Line;
  observation: Observation = null;
  pk: PK;
  wing1: number = 0;
  wing2: number = 0;

  constructor(bt: BT) {
    this.bt = bt;
  }

  convertStringsToNumbers(): Measure {
    this.bt.convertStringsToNumbers();
    this.centralPart = Number(this.centralPart);
    this.height = Number(this.height);
    this.length = Number(this.length);
    this.wing1 = Number(this.wing1);
    this.wing2 = Number(this.wing2);
    return this;
  }

  hasValidWing1() {
    const alertThicknessData: AlertThickness[] = JSON.parse(localStorage.getItem('alertThickness'));    
    const alertThickness = alertThicknessData.find(alertThickness => {
      return alertThickness.line.id === this.pk.line.id &&
             alertThickness.trackAlignment === this.pk.trackAlignment &&
             alertThickness.geographicLocation === this.pk.geographicLocation &&
             alertThickness.steel === this.pk.steel;
    });
    return this.wing1 - alertThickness.value>=0;
  }

  isComplete(): boolean {
    return this.hasValidWing1() || !!(this.centralPart && this.height && this.length && this.wing1 && this.wing2);
  }

  isEmpty(): boolean {
    return !this.isImpossible && !this.centralPart && !this.height && !this.length && !this.wing1 && !this.wing2;
  }

  isValid(): boolean {
    return this.wing1 >= 0 && this.wing1 < 20
      && (this.wing2 == null || (this.wing2 >= 0 && this.wing2 < 20))
      && (this.centralPart == null || (this.centralPart >= 0 && this.centralPart < 20))
      && (this.height == null || (this.height >=0 && this.height < 300))
      && (this.length == null || (this.length >= 0 && this.length < 300));
  }

  setId(id: number): Measure {
    this.id = id;
    return this;
  }

  setBt(bt: BT): Measure {
    this.bt = bt;
    return this;
  }

  setCentralPart(centralPart: number): Measure {
    this.centralPart = centralPart;
    return this;
  }

  setComplementaryValues(measure): Measure {
    if (measure) {
      this.setCentralPart(measure.centralPart)
        .setHeight(measure.height)
        .setLength(measure.length)
        .setWing1(null)
        .setWing2(measure.wing2);
    }
    return this;
  }

  setDate(date: string): Measure {
    this.date = date;
    return this;
  }

  setHeight(height: number): Measure {
    this.height = height;
    return this;
  }

  setIsImpossible(isImpossible: boolean): Measure {
    this.isImpossible = isImpossible;
    return this;
  }

  setIsSpecific(isSpecific: boolean): Measure {
    this.isSpecific = isSpecific;
    return this;
  }

  setLength(length: number): Measure {
    this.length = length;
    return this;
  }

  setLine(line: Line): Measure {
    this.line = line;
    return this;
  }

  setNewDate(): Measure {
    this.date = moment().format('YYYY-MM-DD HH:mm:ss');
    return this;
  }

  setObservation(observation: Observation): Measure {
    this.observation = observation;
    return this;
  }

  setPk(pk: PK): Measure {
    this.pk = pk;
    return this;
  }

  setWing1(wing1: number): Measure {
    this.wing1 = wing1;
    return this;
  }

  setWing2(wing2: number): Measure {
    this.wing2 = wing2;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/measure.ts